import * as Table from 'aem-libs-react-components/src/components/lists/table'
import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'

import { StyledTable, TableWrapper } from './components/ContentTable.styled'
import { testIds } from './e2e/testIds'
import type { ContentTableParams } from './types'

const getMaxColumns = (rows: ContentTableParams['rows']): number => {
  return rows.reduce((max, row) => Math.max(max, row.columns?.length ?? 0), 0)
}

export const App = () => {
  const { rows = [], headingRow = false, headingColumn = false } = useDynamicParams<ContentTableParams>()

  if (!rows || rows.length === 0) {
    return null
  }

  const maxColumns = getMaxColumns(rows)
  const headerRow = headingRow ? rows[0] : null
  const bodyRows = headingRow ? rows.slice(1) : rows

  const renderCell = (html: string, rowIndex: number, colIndex: number) => {
    const content = <span dangerouslySetInnerHTML={{ __html: html }} />
    const key = `${rowIndex}-${colIndex}`

    return <Table.Td key={key}>{content}</Table.Td>
  }

  const renderRow = (row: ContentTableParams['rows'][number], rowIndex: number, isHeader = false) => {
    const columns = row.columns || []

    const renderCellByIndex = (i: number) => {
      const column = columns[i]

      if (isHeader) {
        return <Table.Th key={i}>{column && <span dangerouslySetInnerHTML={{ __html: column.text }} />}</Table.Th>
      }

      if (!column) {
        return <Table.Td key={i} />
      }

      return renderCell(column.text, rowIndex, i)
    }

    const cells = Array.from({ length: maxColumns }, (_, i) => renderCellByIndex(i))

    return <Table.Tr key={rowIndex}>{cells}</Table.Tr>
  }

  return (
    <TableWrapper>
      <StyledTable stickyFirstColumn={headingColumn} data-testid={testIds.contentTable}>
        {headerRow && <Table.THead>{renderRow(headerRow, 0, true)}</Table.THead>}
        <Table.TBody>{bodyRows.map((row, index) => renderRow(row, index))}</Table.TBody>
      </StyledTable>
    </TableWrapper>
  )
}
